/**
 * Animation timing constants for FeedbackModal
 * 
 * Note: These JavaScript constants are used for setTimeout/setInterval logic.
 * For CSS animations, we use SCSS variables in the respective .module.scss files
 * to avoid CSS Modules compatibility issues with :root selectors.
 */
export const ANIMATION_TIMINGS = {
  // Modal animation sequence
  BLUR_DURATION: 233,                    // Duration for content blur effect
  IMAGE_ANIMATION_TRIGGER_DELAY: 700,    // When to show background/content after image animation
  BRIEF_DELAY: 233,                      // Brief delay before starting image animation
  
  // Close animation sequence
  CONTENT_FADEOUT_DELAY: 200,            // Time for content to fade out
  REVERSE_ANIMATION_DURATION: 1000,      // Duration for reverse image animation
  
  // Modal cleanup
  MODAL_CLOSE_ANIMATION: 400,            // Time to wait for close animation
};

/**
 * Animation easing functions
 */
export const ANIMATION_EASINGS = {
  MODAL_CONTENT: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
  SMOOTH: 'cubic-bezier(0.4, 0, 0.2, 1)',
  BOUNCE: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
};

/**
 * Animation states for the feedback modal
 */
export const ANIMATION_STATES = {
  IDLE: 'idle',
  BLURRING: 'blurring',
  ANIMATING: 'animating',
  CONTENT_VISIBLE: 'contentVisible',
  CLOSING: 'closing',
  REVERSING: 'reversing',
};

/**
 * Numeric states for parent communication
 */
export const MODAL_STATES = {
  START_BLUR: 1,
  START_IMAGE_ANIMATION: 2,
  END_BLUR: 6,
  CLOSING: 'closing',
  REVERSING: 'reversing',
};
